import { useEffect } from "react";
import { commitUndo } from "../lib/undo";

/**
 * Continuous inputs (sliders, color picker, dragging the gizmo) pause undo
 * tracking while editing so every intermediate value doesn't become its own
 * undo step. Whatever pauses tracking is responsible for resuming it, but if
 * that's ever missed (e.g. a drag interrupted by an unmount), undo/redo would
 * stay silently broken forever. Committing on every pointer release anywhere
 * in the app is a safe, idempotent backstop (commitUndo is a no-op unless
 * something is actually paused).
 */
export function useUndoSafetyNet() {
  useEffect(() => {
    window.addEventListener("pointerup", commitUndo);
    window.addEventListener("pointercancel", commitUndo);
    return () => {
      window.removeEventListener("pointerup", commitUndo);
      window.removeEventListener("pointercancel", commitUndo);
    };
  }, []);
}
